export default "__VITE_ASSET__6OdX_bcS__"